import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import depositApi from 'api/depositApi';
import CopyText from 'components/Commons/CopyText';
import Typo from 'consts/typography';
import useUserDetail from 'hooks/useUserDetail';
import { DepositReponseAssetModel } from 'models/deposit';
import React, { useEffect, useState } from 'react';
import { text } from 'stream/consumers';
import { shortenAddress } from 'utils/commonUtils';
interface CryptoContainerProps {}

const CryptoContainer: React.FunctionComponent<CryptoContainerProps> = () => {
  const { currentUser } = useUserDetail();
  const [addresses, setAdresses] = useState<DepositReponseAssetModel[]>([]);

  const getUserAddresses = async () => {
    const { ok, body } = await depositApi.getAddresses();

    if (ok && body) {
      setAdresses(body);
    }
  };

  useEffect(() => {
    if (currentUser && currentUser?.kyc?.status === 'APPROVED') {
      getUserAddresses();
    }
  }, [currentUser?.id]);
  return (
    <div className="crypto-container-modal">
      {addresses.length > 0 &&
        addresses
          .sort((a, b) => a.asset.coin.id - b.asset.coin.id)
          .map((address) => <CryptoItem address={address} />)}
    </div>
  );
};

type CryptoItemProps = {
  address: DepositReponseAssetModel;
};

const CryptoItem: React.FunctionComponent<CryptoItemProps> = ({ address }) => {
  return (
    <div key={address.asset.assetId} className="crypto-container-item">
      <div className="crypto-container-icon">
        <img
          className="crypto-coin-symbol"
          src={address.asset.coin.image}
          alt={address.asset.coin.name}
        />
        <img
          className="crypto-chain-symbol"
          src={address.asset.chain.image}
          alt={address.asset.chain.name}
        />
      </div>
      <span className={`primary-text-color ${Typo.p5}`}>
        {address.asset.coin.symbol}/{address.asset.chain.symbol}
      </span>
      <CopyText text={shortenAddress(address.address)} copyText={address.address} />
      {address.tag && <CopyText text={address.tag} copyText={address.tag} />}
    </div>
  );
};

export default CryptoContainer;
